export default async function ({ app, store }) {
  if (!store.state.courses.types.length) {
    const locale = app.i18n.locale;
    const messages = app.i18n.messages?.[locale] || {};
    app.store.dispatch('courses/GET_TYPES', { messages });
  }
}
